import React from "react";

const AgendaCard = ({
  time,
  description,
  speaker,
  details,
  panelists,
  moderator,
  openingSession,
  panelTitle,
}) => {
  return (
    <div className="flex flex-col md:flex-row md:items-start text-white/90 gap-3 md:gap-6">
      <span className="font-semibold text-[1.8rem] bg-gradient-to-r from-brandGreen to-softGreen bg-clip-text text-transparent w-full md:w-1/4 min-w-[100px] xxs:text-xl xs:text-xl">
        {time}
      </span>

      <div className="flex-1 flex flex-col relative before:hidden md:before:block md:before:absolute md:before:top-0 md:before:left-[-18px] md:before:h-full md:before:w-[1px] md:before:bg-gray-400/60 md:before:rounded-full">
        <span className="text-[1.2rem] xs:text-sm xxs:text-sm font-bold">
          {description}
        </span>

        {openingSession && openingSession.length > 0 && (
          <ul className="mt-2 space-y-1">
            {openingSession.map((item, index) => (
              <li
                key={index}
                className="text-sm text-white/80 xs:text-xs xxs:text-xs flex items-start"
              >
                <span className="text-brandGreen mr-2 mt-1">•</span>
                {item}
              </li>
            ))}
          </ul>
        )}

        {panelTitle && (
          <h4 className="text-base font-bold text-white mt-4 mb-2">
            {panelTitle}
          </h4>
        )}

        {details && (
          <ul className="mt-2 space-y-1">
            {details.map((detail, index) => (
              <li
                key={index}
                className="text-sm text-white/80 xs:text-xs xxs:text-xs flex items-start"
              >
                <span className="text-brandGreen mr-2 mt-1">•</span>
                {detail}
              </li>
            ))}
          </ul>
        )}

        {panelists && panelists.length > 0 && (
          <div className="mt-4">
            <h4 className="text-base font-semibold text-white mb-2">
              Panelists:
            </h4>
            <ul className="space-y-1">
              {panelists.map((panelist, index) => (
                <li
                  key={index}
                  className="text-sm text-white/80 xs:text-xs xxs:text-xs flex items-start"
                >
                  <span className="text-brandGreen mr-2 mt-1">•</span>
                  {panelist}
                </li>
              ))}
            </ul>
          </div>
        )}

        {moderator && (
          <div className="mt-3">
            <h4 className="text-base font-semibold text-white mb-1">
              Moderator:
            </h4>
            <div className="text-sm text-white/80 xs:text-xs xxs:text-xs flex items-start">
              <span className="text-brandGreen mr-2 mt-1">•</span>
              {moderator}
            </div>
          </div>
        )}

        {speaker && (
          <span className="text-sm text-brandGreen xs:text-xs xxs:font-xs font-medium mt-1">
            {speaker}
          </span>
        )}
      </div>
      <div className="border-t border-white/10 mt-2 md:hidden" />
    </div>
  );
};

export default AgendaCard;
